module.exports = __webpack_public_path__ + "img/card-img4.7bd64229.png";